import { establishmentApi } from '@/core/api/establishment'

export const {
  useGetEstablishmentQuery,
  useGetEstablishmentBackgroundsQuery,
  useUpdateEstablishmentMutation,
  useUpdateIdentityJustificationTypesMutation,
  useDeleteIdentityJustificationTypeMutation,
  useListTrustedActorsQuery,
  useAddTrustedActorMutation,
  useUpdateTrustedActorMutation,
  useRemoveTrustedActorMutation,
  useListExternalHealthDataWorklistQuery,
  useIngestExternalIdentityMutation,
  useRegisterIdentityVerificationKoMutation,
} = establishmentApi
